import { render, staticRenderFns } from "./EditStagingKendaraan.vue?vue&type=template&id=39b47c27&"
import script from "./EditStagingKendaraan.vue?vue&type=script&lang=js&"
export * from "./EditStagingKendaraan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports